import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "role-form" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BButton = _resolveComponent("BButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BButtonGroup = _resolveComponent("BButtonGroup")!
  const _component_BButtonToolbar = _resolveComponent("BButtonToolbar")!
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_BFormGroup = _resolveComponent("BFormGroup")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_FeaturesPanel = _resolveComponent("FeaturesPanel")!
  const _component_BOverlay = _resolveComponent("BOverlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BOverlay, {
      show: _ctx.formLoading,
      rounded: "sm",
      variant: "white",
      opacity: "0.6",
      blur: "2px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(this.entity.id ? "Edit" : "Create") + " " + _toDisplayString(_ctx.$t("tenantForm.tenant")) + " " + _toDisplayString(_ctx.entity.name), 1),
        _createVNode(_component_BButtonToolbar, { class: "mb-2 pt-2 pb-2 border-light border-top border-bottom" }, {
          default: _withCtx(() => [
            _createVNode(_component_BButtonGroup, null, {
              default: _withCtx(() => [
                _createVNode(_component_BButton, {
                  size: "sm",
                  variant: "outline-primary",
                  onClick: _ctx.onClose,
                  class: "custom-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("tenantForm.close")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_BButton, {
                  disabled: !_ctx.isDirty,
                  class: "ml-2",
                  size: "sm",
                  variant: "primary",
                  onClick: _ctx.onSave,
                  style: {"background-color":"#0054a6"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "save" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("tenantForm.save")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_BForm, { ref: "form" }, {
              default: _withCtx(() => [
                _createVNode(_component_BFormGroup, {
                  id: "input-group-name",
                  description: "Name should be unique.",
                  label: "Name:",
                  "label-for": "input-name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BFormInput, {
                      id: "input-name",
                      modelValue: _ctx.entity.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.name) = $event)),
                      placeholder: "Enter Tenant Name",
                      required: "",
                      type: "text",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeEvent(_ctx.entity.name)))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.isCreateMode)
                  ? (_openBlock(), _createBlock(_component_BFormGroup, {
                      key: 0,
                      id: "input-group-tenant-id",
                      label: "Tenant Id:",
                      "label-for": "input-tenant-id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_BFormInput, {
                          id: "input-tenant-id",
                          modelValue: _ctx.tenantId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tenantId) = $event)),
                          required: "",
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isCreateMode)
                  ? (_openBlock(), _createBlock(_component_BFormGroup, {
                      key: 1,
                      id: "input-group-databaseName",
                      label: "Database Name:",
                      "label-for": "input-databaseName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_BFormInput, {
                          id: "input-databasename",
                          modelValue: _ctx.databaseName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.databaseName) = $event)),
                          required: "",
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.formReady)
              ? (_openBlock(), _createBlock(_component_FeaturesPanel, {
                  key: 0,
                  disabled: _ctx.isCreateMode || !_ctx.canModifyPermissions,
                  "provider-name": "T",
                  "provider-key": this.id
                }, null, 8, ["disabled", "provider-key"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}